import React from 'react';

const compareIcon = () => (
    <svg viewBox="0 0 70 70">
        <polygon points="5.615,5 32.765,35 5.615,65" />
        <polygon points="64.385,65 37.235,35 64.385,5" />
    </svg>
)

export default compareIcon